import { Component, Input, OnInit } from '@angular/core';
import { ServiceWizard } from '../../../../shared/state/service-wizard/service-wizard.model';
import { AppointmentWizardDate } from '../../../../shared/state/appointment-wizard-date/appointment-wizard-date.model';
import { AppointmentWizardTime } from '../../../../shared/state/appointment-wizard-time/appointment-wizard-time.model';
import { GenericKeysModel } from '../../../../shared/models';
import { Observable } from 'rxjs';
import { SettingsQuery } from '../../../../shared/state/settings/settings.query';
import { Clinic } from 'src/app/shared/state/clinic/clinic.store';
import { ClinicDetailService } from 'src/app/shared/state/clinic-detail/clinic-detail.service';
import { ServicesGroup } from 'src/app/shared/state/services-group/services-group.model';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
})
export class ConfirmComponent implements OnInit {
    @Input() servicesCheked: ServiceWizard[];
    @Input() dateActive: AppointmentWizardDate;
    @Input() timeActive: AppointmentWizardTime;
    @Input() appDelegate: boolean;
    /** Flowwwer template */
    @Input() servicesGroups: ServicesGroup[];

    genericKeyVoooy = GenericKeysModel.Voooy;

    genericKey$: Observable<number>;

    currentClinic: Clinic;

    constructor(
        private settingsQuery: SettingsQuery,
        private clinicDetailService: ClinicDetailService
    ) {}

    get servicesDescription() {
        if (this.servicesCheked && this.servicesCheked.length > 0) {
            return this.servicesCheked.map((s) => s.description);
        }

        return [];
    }

    ngOnInit(): void {
        this.genericKey$ = this.settingsQuery.select('genericKey');
        this.currentClinic = this.clinicDetailService.getCurentClinicDeatil2Clinic();
    }
}
